import React, { useState } from "react";
import {  Card, Input, Button, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../../services/AuthService.ts";
import CustomSpinner from "../../core/spinner/CustomSpinner.tsx";
import "./Login.css";

const { Title } = Typography;

const LoginComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [company, setCompany] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const redirectPath = (location.state as { from: Location })?.from?.pathname || "/";

  const handleLogin = async () => {
    if(!company.trim()){
      return;
    }
    try {
      setIsLoading(true);
      const authService = AuthService.getInstance();

      await authService.loadAppConfig();
      await authService.loadAzureConfigByCompany(company);
      await authService.initializeMsalClient()
      await authService.login();

      localStorage.setItem("company", company);

      navigate(redirectPath, { replace: true });
    } catch (error) {
      navigate("/login")
      localStorage.removeItem("company");
      setIsLoading(false);
    }
  };

  if(isLoading){
    return <CustomSpinner />;
  }

  return (
    <div className="login-container">
    <Card className="login-card">
      <Title level={3} className="login-title">
        Sign in to continue
      </Title>
      <div className="login-input-container">
        <label htmlFor="company" className="login-input-label">Your company name</label>
        <Input
          id="company"
          className="login-input"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
        />
      </div>
      <Button 
        type="primary" 
        size="large" 
        onClick={handleLogin}
        className="login-button"
      >
        Log in with Microsoft
      </Button>
    </Card>
  </div>
  );
};

export default LoginComponent;
